
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1983"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1983"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $f6d0ce77acbad9ef$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["6oMUc","index.44dafa5c.js","8wHGX","pokeball.59f018b0.png","kv0j8","pokemon-logo.b52e5012.png"]'));

const $f381a3c3b9cf5311$export$ca000e230c0caa3e = {
    type: "",
    pokemon: [],
    cards: [],
    deck: []
};
const $f381a3c3b9cf5311$export$61abde59b50deb8e = `https://pokeapi.co/api/v2/pokemon/`;
const $f381a3c3b9cf5311$export$e0e8d694bc1e558e = 6;
const $f381a3c3b9cf5311$export$71201b0fbc775072 = async function() {
    try {
        const resPokemon = await fetch(`${$f381a3c3b9cf5311$export$61abde59b50deb8e}?limit=200`);
        const dataPokemon = await resPokemon.json();
        const pokeArr = await Promise.all(dataPokemon.results.map(async function(pok) {
            const res = await fetch(pok.url);
            const data = await res.json();
            //   console.log(data);
            return data;
        }));
        return pokeArr;
    } catch (error) {}
};
const $f381a3c3b9cf5311$export$d39fdbaf795265a7 = async function(url, type) {
    $f381a3c3b9cf5311$export$ca000e230c0caa3e.type = type;
    type = type.toLowerCase();
    const pokeArr = await $f381a3c3b9cf5311$export$71201b0fbc775072();
    const typeArr = pokeArr.filter((pok)=>pok.types.some((t)=>t.type.name === type));
    typeArr.forEach((pok)=>{
        $f381a3c3b9cf5311$export$ca000e230c0caa3e.pokemon.push(pok);
        $f381a3c3b9cf5311$export$ca000e230c0caa3e.cards.push(pok);
    });
};
const $f381a3c3b9cf5311$export$f561669b512b410 = function(pokemon) {
    const index = $f381a3c3b9cf5311$export$ca000e230c0caa3e.pokemon.findIndex((pok)=>pok.name === pokemon);
    $f381a3c3b9cf5311$export$ca000e230c0caa3e.deck.push($f381a3c3b9cf5311$export$ca000e230c0caa3e.pokemon[index]);
};
const $f381a3c3b9cf5311$export$8c380205b8afd0ac = function() {
    $f381a3c3b9cf5311$export$ca000e230c0caa3e.cards.splice(0, $f381a3c3b9cf5311$export$ca000e230c0caa3e.pokemon.length);
    console.log($f381a3c3b9cf5311$export$ca000e230c0caa3e);
};
const $f381a3c3b9cf5311$export$7746a789a561285f = function() {
    $f381a3c3b9cf5311$export$ca000e230c0caa3e.deck.splice(0, $f381a3c3b9cf5311$export$ca000e230c0caa3e.deck.length);
};


class $aa1be1c9ab742abe$export$2e2bcd8739ae039 {
    _data;
    formWindow = document.querySelector(".choose-pokemon-window");
    titleScreen = document.querySelector(".title-screen");
    typeBtnsContainer = document.querySelector(".type-buttons");
    cardsContainer = document.querySelector(".hp__card-container");
    deckContainer = document.querySelector(".hp__deck-container");
    render(data, deck = false) {
        this._data = data;
        const markup = this._generateMarkup();
        this._parentEl.innerHTML = "";
        if (deck) {
            this.showParent();
            this.titleScreen.classList.remove("hidden");
        }
        this._parentEl.insertAdjacentHTML("afterbegin", markup);
        if (this._parentEl === document.querySelector(".hp__card-container")) this._parentEl.scrollLeft = 0;
    }
    reset(data) {
        this._data = data;
        const markup = this._generateMarkupReset();
        this._parentEl.innerHTML = "";
        this._parentEl.insertAdjacentHTML("afterbegin", markup);
    }
    renderSpinner() {
        console.log("spinner");
        const markup = `
    <div class="">
     
      <span class="loading-text">Loading...</span>
    </div>`;
        this._parentEl.innerHTML = "";
        this._parentEl.insertAdjacentHTML("afterbegin", markup);
    }
    showParent() {
        this._parentEl.classList.remove("hidden");
    }
    hideParent() {
        this._parentEl.classList.add("hidden");
    }
    adjustPos() {
        this._parentEl.style.transform = "translateY(-50px)";
    }
    toggleForm = function() {
        this.titleScreen.classList.toggle("hidden");
        this.formWindow.classList.toggle("hidden");
        if (!this.deckContainer.classList.contains("hidden")) this.deckContainer.classList.add("hidden");
    };
    hideForm = function() {
        this.titleScreen.classList.add("hidden");
        this.formWindow.classList.add("hidden");
    };
}


class $4291597b836f543f$var$CardsView extends (0, $aa1be1c9ab742abe$export$2e2bcd8739ae039) {
    _parentEl = document.querySelector(".cards");
    _generateMarkup() {
        const markup = `<h3 class="cards-heading">Select Pokemon </h3>
      <h4 class="cards-subheading">Scroll -></h4>
      <div class="hp__card-container ">
      <ul class="hp__card-list">` + this._data.cards.map((pok)=>{
            return `
  
    <li class="hp__card-item">
      <div class="hp__card">
        <h3 class="hp__card-title">${pok.name[0].toUpperCase() + pok.name.slice(1)}</h3>
        <img src="${pok.sprites.front_default}" alt="Charmander" class="hp__card-image" />
        <p class="hp__card-type">${this._data.type}</p>
      </div>
    </li> `;
        }).join("") + `</ul>
      </div>`;
        return markup;
    }
    hideFormShowCards() {
        this.hideForm();
        this._parentEl.classList.remove("hidden");
    }
    addHandlerCardSelect(handler) {
        this._parentEl.addEventListener("click", function(e) {
            const card = e.target.closest(".hp__card-item");
            if (!card) return;
            const pokemonName = card.querySelector(".hp__card-title").textContent.toLowerCase();
            const cryUrl = `https://play.pokemonshowdown.com/audio/cries/${pokemonName}.mp3`;
            const cryAudio = new Audio(cryUrl);
            // cryAudio
            //   .play()
            //   .catch((error) => console.error("Cry not available for:", pokemonName));
            handler(pokemonName);
        });
    }
}
var $4291597b836f543f$export$2e2bcd8739ae039 = new $4291597b836f543f$var$CardsView();




class $761aff36590b777d$var$DeckView extends (0, $aa1be1c9ab742abe$export$2e2bcd8739ae039) {
    _parentEl = document.querySelector(".hp__deck-container");
    _generateMarkup() {
        const markup = this._data.map((pok)=>{
            return `
        <li class="hp__card-item">
          <div class="hp__card">
            <h3 class="hp__card-title">${pok.name[0].toUpperCase() + pok.name.slice(1)}</h3>
            <img src="${pok.sprites.front_default}" alt="${pok.name}" class="hp__card-image" />
            <p class="hp__card-type">${pok.types.map((type)=>type.type.name).join(", ")}</p>
          </div>
        </li>`;
        }).join("");
        return markup;
    }
}
var $761aff36590b777d$export$2e2bcd8739ae039 = new $761aff36590b777d$var$DeckView();



class $778d11d121a008f7$var$NumberView extends (0, $aa1be1c9ab742abe$export$2e2bcd8739ae039) {
    _parentEl = document.querySelector(".secondary-text");
    _generateMarkup() {
        console.log(this._data.length);
        const markup = `...${this._data.length <= 6 ? this._data.length : 6} out of 6`;
        return markup;
    }
}
var $778d11d121a008f7$export$2e2bcd8739ae039 = new $778d11d121a008f7$var$NumberView();



var $8b25ded590dc6d1f$exports = {};
$8b25ded590dc6d1f$exports = new URL("pokeball.59f018b0.png", import.meta.url).toString();


var $afe69f46f1e0b704$exports = {};
$afe69f46f1e0b704$exports = new URL("pokemon-logo.b52e5012.png", import.meta.url).toString();


class $d4ad1c18d0084f85$var$titleView extends (0, $aa1be1c9ab742abe$export$2e2bcd8739ae039) {
    _parentEl = document.querySelector(".title-screen");
    _generateMarkup() {
        const markup = `
    <div class="title__img-container">
        
        <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($afe69f46f1e0b704$exports)))}" class="title__img logo"/>
        <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($8b25ded590dc6d1f$exports)))}" class="title__img pokeball"/>
      </div>
    <h1 class="title-screen__heading">Congrats! Ready for Battle! </br>
        <span class="secondary-text">6 of 6 Pokemon Ready</span>
    </h1>
    <a class="title-screen__btn-start" href="#">Play again</a>`;
        return markup;
    }
    _generateMarkupReset() {
        return `
  <div class="title__img-container">
    <img src="${0, (/*@__PURE__*/$parcel$interopDefault($afe69f46f1e0b704$exports))}" class="title__img logo"/>
    <img src="${0, (/*@__PURE__*/$parcel$interopDefault($8b25ded590dc6d1f$exports))}" class="title__img pokeball"/>
  </div>
  <h1 class="title-screen__heading">Choose your Pokemon </br>
    <span class="secondary-text">...0 of 6</span></h1>
  <a class="title-screen__btn-start" href="#">Start</a>
  `;
    }
}
var $d4ad1c18d0084f85$export$2e2bcd8739ae039 = new $d4ad1c18d0084f85$var$titleView();



class $595145eb00b58e7c$var$FormView extends (0, $aa1be1c9ab742abe$export$2e2bcd8739ae039) {
    _parentEl = document.querySelector(".choose-pokemon-window");
    _generateMarkup() {
        const markup = ` <form class="form ">
    <!--Unordered list for each quesstion?  -->
   <h3 class="form-heading">Select Pokemon Type...</h3>
   <!-- <label>Type</label> -->
   <div class="type-buttons">
       <div class="type-button fire" role="button" tabindex="0">
           <span class="icon">\u{1F525}</span>
           <span class="btn-text">Fire</span>
       </div>
       <div class="type-button water" role="button" tabindex="0">
           <span class="icon">\u{1F4A7}</span>
           <span class="btn-text">Water</span>
       </div>
       <div class="type-button electric" role="button" tabindex="0">
           <span class="icon">\u{26A1}</span>
           <span class="btn-text">Electric</span>
       </div>
       <div class="type-button grass" role="button" tabindex="0">
           <span class="icon">\u{1F331}</span>
           <span class="btn-text">Grass</span>
       </div>
       <div class="type-button ice" role="button" tabindex="0">
           <span class="icon">\u{2744}\u{FE0F}</span>
           <span class="btn-text">Ice</span>
       </div>
       <div class="type-button fighting" role="button" tabindex="0">
           <span class="icon">\u{1F94A}</span>
           <span class="btn-text">Fighting</span>
       </div>
       <div class="type-button poison" role="button" tabindex="0">
           <span class="icon">\u{2620}\u{FE0F}</span>
           <span class="btn-text">Poison</span>
       </div>
       <div class="type-button ground" role="button" tabindex="0">
           <span class="icon">\u{1F30D}</span>
           <span class="btn-text">Ground</span>
       </div>
       <div class="type-button flying" role="button" tabindex="0">
           <span class="icon">\u{1F54A}\u{FE0F}</span>
           <span class="btn-text">Flying</span>
       </div>
       <div class="type-button psychic" role="button" tabindex="0">
           <span class="icon">\u{1F52E}</span>
           <span class="btn-text">Psychic</span>
       </div>
       <div class="type-button bug" role="button" tabindex="0">
           <span class="icon">\u{1F41B}</span>
           <span class="btn-text">Bug</span>
       </div>
       <div class="type-button rock" role="button" tabindex="0">
           <span class="icon">\u{1FAA8}</span>
           <span class="btn-text">Rock</span>
       </div>
       <div class="type-button ghost" role="button" tabindex="0">
           <span class="icon">\u{1F47B}</span>
           <span class="btn-text">Ghost</span>
       </div>
       <div class="type-button dragon" role="button" tabindex="0">
           <span class="icon">\u{1F409}</span>
           <span class="btn-text">Dragon</span>
       </div>
       <div class="type-button dark" role="button" tabindex="0">
           <span class="icon">\u{1F311}</span>
           <span class="btn-text">Dark</span>
       </div>
       <div class="type-button steel" role="button" tabindex="0">
           <span class="icon">\u{1F529}</span>
           <span class="btn-text">Steel</span>
       </div>
       <div class="type-button fairy" role="button" tabindex="0">
           <span class="icon">\u{1F9DA}</span>
           <span class="btn-text">Fairy</span>
       </div>
       <div class="type-button normal" role="button" tabindex="0">
           <span class="icon">\u{26AA}</span>
           <span class="btn-text">Normal</span>
       </div>
   </div>

   
<!--         
   <label>Size</label>
   <select class="size">
     <option value="small">Small</option>
     <option value="medium">Medium</option>
     <option value="large">Large</option>
   </select> -->
   <!-- <input class="size" type="text" /> -->

   
 </form>`;
        return markup;
    }
}
var $595145eb00b58e7c$export$2e2bcd8739ae039 = new $595145eb00b58e7c$var$FormView();


// Elements
const $03cf872f16b5d10b$var$formWindow = document.querySelector(".choose-pokemon-window");
const $03cf872f16b5d10b$var$titleScreen = document.querySelector(".title-screen");
const $03cf872f16b5d10b$var$typeBtnsContainer = document.querySelector(".type-buttons");
const $03cf872f16b5d10b$var$cardsContainer = document.querySelector(".hp__card-container");
const $03cf872f16b5d10b$var$copyright = document.querySelector(".copyright");
// Event Handler Functions
// Controllers
const $03cf872f16b5d10b$var$controlSelectType = async function(type) {
    (0, $595145eb00b58e7c$export$2e2bcd8739ae039).renderSpinner();
    // Change state
    await $f381a3c3b9cf5311$export$d39fdbaf795265a7($f381a3c3b9cf5311$export$61abde59b50deb8e, type);
    // Render cards using new state data
    (0, $4291597b836f543f$export$2e2bcd8739ae039).hideFormShowCards();
    (0, $4291597b836f543f$export$2e2bcd8739ae039).render($f381a3c3b9cf5311$export$ca000e230c0caa3e);
// titleView.hideParent();
};
const $03cf872f16b5d10b$var$controlAddPokemon = function(pokemon) {
    // Clear pokemon options field so new types can be rendered
    $f381a3c3b9cf5311$export$8c380205b8afd0ac();
    // title screen adjustment
    (0, $d4ad1c18d0084f85$export$2e2bcd8739ae039).adjustPos();
    (0, $761aff36590b777d$export$2e2bcd8739ae039).adjustPos();
    // Add selected pokemon to deck
    $f381a3c3b9cf5311$export$f561669b512b410(pokemon);
    console.log($f381a3c3b9cf5311$export$ca000e230c0caa3e);
    // Increase number by 1
    if ($f381a3c3b9cf5311$export$ca000e230c0caa3e.deck.length > $f381a3c3b9cf5311$export$e0e8d694bc1e558e - 1) (0, $d4ad1c18d0084f85$export$2e2bcd8739ae039).render($f381a3c3b9cf5311$export$ca000e230c0caa3e.deck);
    else (0, $778d11d121a008f7$export$2e2bcd8739ae039).render($f381a3c3b9cf5311$export$ca000e230c0caa3e.deck);
    // render selected cards under title
    (0, $4291597b836f543f$export$2e2bcd8739ae039).hideParent();
    (0, $761aff36590b777d$export$2e2bcd8739ae039).render($f381a3c3b9cf5311$export$ca000e230c0caa3e.deck, true);
};
// Event Listeners
$03cf872f16b5d10b$var$titleScreen.addEventListener("click", function(e) {
    e.preventDefault();
    const btn = e.target.closest(".title-screen__btn-start");
    if (!btn) return;
    $03cf872f16b5d10b$var$copyright.style.display = "none";
    if ($f381a3c3b9cf5311$export$ca000e230c0caa3e.deck.length === $f381a3c3b9cf5311$export$e0e8d694bc1e558e) {
        console.log($f381a3c3b9cf5311$export$e0e8d694bc1e558e);
        $f381a3c3b9cf5311$export$8c380205b8afd0ac();
        $f381a3c3b9cf5311$export$7746a789a561285f();
        (0, $761aff36590b777d$export$2e2bcd8739ae039).render($f381a3c3b9cf5311$export$ca000e230c0caa3e.deck);
        (0, $761aff36590b777d$export$2e2bcd8739ae039).hideParent();
        (0, $d4ad1c18d0084f85$export$2e2bcd8739ae039).reset($f381a3c3b9cf5311$export$ca000e230c0caa3e.deck);
        return;
    } else {
        (0, $595145eb00b58e7c$export$2e2bcd8739ae039).render();
        (0, $595145eb00b58e7c$export$2e2bcd8739ae039).showParent();
        (0, $d4ad1c18d0084f85$export$2e2bcd8739ae039).hideParent();
        if ($f381a3c3b9cf5311$export$ca000e230c0caa3e.deck.length > 0) (0, $761aff36590b777d$export$2e2bcd8739ae039).hideParent();
    }
});
$03cf872f16b5d10b$var$formWindow.addEventListener("click", function(e) {
    e.preventDefault();
    const btn = e.target.closest(".type-button");
    if (!btn) return;
    $03cf872f16b5d10b$var$controlSelectType(btn.querySelector(".btn-text").textContent);
});
const $03cf872f16b5d10b$var$init = function() {
    (0, $4291597b836f543f$export$2e2bcd8739ae039).addHandlerCardSelect($03cf872f16b5d10b$var$controlAddPokemon);
};
$03cf872f16b5d10b$var$init(); /*
///////////////////////////////
// To do list
1. Number changes with each pokemon chosen (1, 2, 3, 4, 5) ✅

2. Export hiding functionality out of universal render() method ✅
2. Refactor View.returnToMenu(deck) to fit in with View.render✅

3. Change container styling for cards and deck

4. Play again functionality


*/ 


//# sourceMappingURL=index.44dafa5c.js.map
